<template>
  <md-drawer md-permanent="clipped" class="mo-dashboard-drawer">
    <md-list>
      <md-list-item to="/dashboard">
        <md-icon>move_to_inbox</md-icon>
        <span class="md-list-item-text">Listings</span>
      </md-list-item>

      <!-- <md-list-item :to="{name:'dashboardRequests'}">
        <md-icon>send</md-icon>
        <span class="md-list-item-text">Requests</span>
      </md-list-item> -->
    </md-list>
  </md-drawer>
</template>

<script>
  export default {
    data() {
      return {}
    },
    computed: {},
    created(){},
    methods: {}
  }
</script>
<style scoped>
  @import '../../assets/styles/global.css';
</style>



// WEBPACK FOOTER //
// src/components/dashboard/dashDrawer.vue